<template>
  <div class="col-12 d-flex justify-content-center mt-3" v-if="ticketData">

    <div id="ticket-main-wrapper-container" class="ticket-main-wrapper col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-7" :class="{ 'center-on-print': this.store.state.customer.printing }">
      <div class="ticket-print-button text-gray" v-bind:title=" $t('print') ">
        <span id="ticket-print-button" @click.prevent="print()">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-printer">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
        </span>
      </div>
      <div class="ticket-header-route mx-auto">
        {{ ticketData.title }}
      </div>
      <div class="ticket-departure-arrival-wrapper d-flex justify-content-between">
        <ul class="ticket-departure-arrival-info1">
          <li class="">{{ $t('departure') }}</li>
          <li class="">{{ ticketData.pickup_addr.address_to_show }}</li>
          <li class="">{{ ticketData.pickup_addr.address }}</li>
        </ul>
        <div class="ticket-departure-arrival-info-first mt-3">
          <div class="ticket-departure-arrival-info-second">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9999 25.6663C20.4432 25.6663 25.6666 20.443 25.6666 13.9997C25.6666 7.55635 20.4432 2.33301 13.9999 2.33301C7.5566 2.33301 2.33325 7.55635 2.33325 13.9997C2.33325 20.443 7.5566 25.6663 13.9999 25.6663Z" stroke="#0029FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 7V14L18.6667 16.3333" stroke="#0029FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              <span class="info-text">{{ ticketData.pickup.split(' ')[1] }}</span>
          </div>

          <div class="ticket-departure-arrival-info-second">
            <svg width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.6667 1.33325V3.99992" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.33334 1.33325V3.99992" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 6.66675H14" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              <span class="info-text">{{ ticketData.pickup.split(' ')[0] }}</span>
          </div>

        </div>
      </div>
      <div class="ticket-departure-arrival-wrapper d-flex justify-content-between">
        <ul class="ticket-departure-arrival-info1">
          <li class="">{{ $t('arrival') }}</li>
          <li class="">{{ ticketData.dest_addr.address_to_show }}</li>
          <li class="">{{ ticketData.dest_addr.address }}</li>
        </ul>
        <div class="ticket-departure-arrival-info-first mt-3">
          <div class="ticket-departure-arrival-info-second">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9999 25.6663C20.4432 25.6663 25.6666 20.443 25.6666 13.9997C25.6666 7.55635 20.4432 2.33301 13.9999 2.33301C7.5566 2.33301 2.33325 7.55635 2.33325 13.9997C2.33325 20.443 7.5566 25.6663 13.9999 25.6663Z" stroke="#0029FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 7V14L18.6667 16.3333" stroke="#0029FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              <span class="info-text">{{ ticketData.dropoff.split(' ')[1] }}</span>
          </div>

          <div class="ticket-departure-arrival-info-second">
            <svg width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.6667 1.33325V3.99992" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.33334 1.33325V3.99992" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 6.66675H14" stroke="#0029FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              <span class="info-text">{{ ticketData.dropoff.split(' ')[0] }}</span>
          </div>

        </div>
      </div>
        <div class="d-inline-block w-100 ticket-additional-info">
            <span class="w-50 d-inline-flex justify-content-start" dir="ltr">{{ $t('customer') }}</span>
            <span class="w-50 d-inline-flex justify-content-end">
          {{ ticketData.customer }}
        </span>
        </div>
      <div class="d-inline-block w-100 ticket-additional-info">
        <span class="w-50 d-inline-flex justify-content-start" dir="ltr">{{ $t('duration') }}</span>
        <span class="w-50 d-inline-flex justify-content-end">
          {{ ticketData.duration }} {{$t('shortened_minutes')}}
        </span>
      </div>
      <div class="d-inline-block w-100 ticket-additional-info" v-if="ticketData.total_kms">
        <span class="w-50 d-inline-flex justify-content-start" dir="ltr">{{ $t('distance') }}</span>
        <span class="w-50 d-inline-flex justify-content-end">{{ ticketData.total_kms.toFixed(1) + ' km' }}</span>
      </div>
      <div class="d-inline-block w-100 ticket-additional-info">
        <span class="w-50 d-inline-flex justify-content-start" dir="ltr">{{ $t('passengers') }}</span>
        <span class="w-50 d-inline-flex justify-content-end">{{ ticketData.travellers }}</span>
      </div>
      <div class="d-inline-block w-100 ticket-additional-info">
        <span class="w-50 d-inline-flex justify-content-start" dir="ltr">{{ $t('price') }}</span>
        <span class="w-50 d-inline-flex justify-content-end sum">
          {{ (ticketData.travellers * ticketData.tax_total).toFixed(2) + ' ' + ticketData.total_currency }}
        </span>
      </div>
      <div class="d-flex flex-wrap mt-5">
        <div class="d-flex justify-content-center w-100">
          <div id="qr-code"></div>
        </div>
        <div class="d-flex justify-content-center w-100 ticket-qr-number">
          <span>{{ 'NR. ' + ticketData.id }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import './transportationTicketPage.scss';

import {useStore} from "vuex";
import {defineComponent} from "vue";
import NameOfHelper from "../../helpers/nameOfHelper";
import axios from "axios";
import apiService from "../../services/apiService";

export default defineComponent({
  name: "TransportationTicketPage",
  props: {
    bookingId: {
      type: String,
      required: false
    },
    bookingData: {
      type: String,
      required: false
    }
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
        allBookingData: <any>null,
        ticketData: <any|null>null
    }
  },

  computed: {},

  methods: {
    prepareTicketData(): void {
        const data = this.allBookingData;

        if (! data) {
            return;
        }

        const stops = data.transportation.transportation_stop.map(el => el.transportation_address);
        const allStops = [
            data.transportation.drop_off_address, ...stops, data.transportation.pickup_address
        ];

        this.ticketData = {
            title: data.transportation.title,
            pickup: data.pickup,
            dropoff: data.dropoff,
            customer: data.customer,
            travellers: data.travellers,
            tax_total: data.tax_total,
            total_currency: data.total_currency,
            total_kms: data.total_kms,
            duration: data.duration,
            id: data.id,
            pickup_addr: allStops.filter(el => el.city === data.pickup_addr || el.address_to_show === data.pickup_addr)[0],
            dest_addr: allStops.filter(el => el.city === data.dest_addr || el.address_to_show === data.dest_addr)[0],
            ticket_file_name: data.ticket_file_name,
        };
    },
    countTime(minutes) {
      let hours = (minutes / 60);
      let rhours = Math.floor(hours);
      let mins = (hours - rhours) * 60;
      let rmins = Math.round(mins);

      return rhours + ' h ' + rmins + ' min'
    },

    async print() {
      this.hideComponents();

      setTimeout(() => {
        window.print();

        this.showComponents();
      });
    },

    hideComponents() {
      const state = this.store.state.customer;
      const nameOf = (c) => NameOfHelper.obj(c);

      document.getElementById('ticket-print-button')!.style.display = 'none';

      this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
        {prop: nameOf(() => state.printing), value: true},
      ]);
    },

    showComponents() {
      const state = this.store.state.customer;
      const nameOf = (c) => NameOfHelper.obj(c);

      document.getElementById('ticket-print-button')!.style.display = 'block';

      this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
        {prop: nameOf(() => state.printing), value: false},
      ]);
    }
  },

  created() {
      const bookingId = this.$route.query.id;
      const storageKey = 'booking_history_item_id_' + bookingId;

      let data = localStorage.getItem(storageKey);

      if (data) {
          this.allBookingData = JSON.parse(data);
          this.prepareTicketData();
          return;
      }

      // Cover when we get data from another page
      if (this.bookingData) {
          this.allBookingData = this.bookingData;
          localStorage.setItem(storageKey, JSON.stringify(this.bookingData));
          this.prepareTicketData();

          return;
      }
  },

  mounted() {
      const _this = this;

      if (! this.allBookingData) {
          const bookingId = this.$route.query.id;
          const storageKey = 'booking_history_item_id_' + bookingId;

          axios.get(apiService.customerGetBooking() + this.$route.query.id).then(response => {
              this.allBookingData = response.data.data;
              localStorage.setItem(storageKey, JSON.stringify(this.allBookingData));
              this.prepareTicketData();

              handleQRCode();
          });

          return;
      }

      function handleQRCode() {
          axios.get(apiService.customerGetQRCode() + '?id=' + _this.$route.query.id).then(response => {
              const elm = <HTMLElement>document.getElementById('qr-code');
              elm.innerHTML = '<img src="data:image/png;base64,' + response.data + '" alt="barcode" />';
          });
      }
      handleQRCode();
  }
})
</script>

<style scoped>

</style>